import React from "react";
import PropTypes from "prop-types";
import Svg from "components/elements/svg";

class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: [],
    };
  }

  onItemToggle(index) {
    let expanded = [...this.state.expanded];
    if (expanded.includes(index)) {
      expanded.splice(expanded.indexOf(index), 1);
    } else if (this.props.multiple) {
      expanded.push(index);
    } else {
      expanded = [index];
    }
    this.setState({ expanded });
  }

  render() {
    const { className, children } = this.props;
    let items = [];
    items = Array.isArray(children) ? children : [children];
    return (
      <div className={`accordion${className ? ` ${className}` : ""}`}>
        {items.map((item, index) => ({
          ...item,
          props: {
            ...item.props,
            expanded: this.state.expanded.includes(index),
            onToggle: () => this.onItemToggle(index),
          },
        }))}
      </div>
    );
  }
}

Accordion.Item = ({ expanded, label, children, onToggle }) => (
  <div className={`accordion__item${expanded ? " expanded" : ""}`}>
    <div
      role="tab"
      tabIndex="0"
      className="accordion__item--header"
      onClick={onToggle}
    >
      <div className="accordion__item--header-content">{label}</div>
      <div
        className={`accordion__item--header-aside${
          expanded ? " expanded" : ""
        }`}
      >
        <p className="read-more" aria-hidden={expanded}>
          Read more
        </p>
        <p className="read-less" aria-hidden={!expanded}>
          Read less
        </p>
        <Svg className="icon" src="chevron-down" />
      </div>
    </div>
    <div role="tabpanel" className="accordion__item--content">
      {children}
    </div>
  </div>
);

Accordion.Item.propTypes = {
  expanded: PropTypes.bool,
  label: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  onToggle: PropTypes.func,
};

Accordion.Item.defaultProps = {
  expanded: false,
  onToggle: () => null,
};

Accordion.Item.displayName = "AccordionItem";

Accordion.propTypes = {
  multiple: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Accordion.defaultProps = {
  className: "",
  multiple: true,
};

export default Accordion;
